/**
 * @file JS - Helpers - GlobalFunctions.js
 * @author Adam Lemire
 * @since 2019/11/19
 * @version 1.0
 * @summary Dernières modifications : 2021/07/22
 */

import $ from 'jquery';
import { GisButton, ContextMenu } from './Selectors.js';

/**
 */
export function hideContextMenus () {
  $(ContextMenu.ALL).each(function () {
    if (!$(this).hasClass('hidden')) {
      $(this).addClass('hidden');
    }
  });
  if ($(GisButton.GIS_PROJECT_MENU).hasClass('active')) {
    $(GisButton.GIS_PROJECT_MENU).toggleClass('active');
  }
}

/**
 * @param {Array} array
 * @param {callback} callback
 */
export async function asyncForEach (array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

/**
 * @param {number} alpha - (opt) opacity 0 to 1
 * @returns {string}
 */
export function getRandomRGBAColor (alpha = 1) {
  const red = Math.floor((Math.random() * 255));
  const green = Math.floor((Math.random() * 255));
  const blue = Math.floor((Math.random() * 255));
  const rgba = 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
  return rgba;
}

/**
 * @param { number } amount
 * @param { number } saturation - opt, defaut = 100
 * @param { number } lightness - opt, defaut = 50
 * @param { number } alpha - opt, defaut = 1
 * @returns { [string] }
 */
export function generateHslaColors (amount, saturation = 100, lightness = 500, alpha = 1.0) {
  const colors = [];
  const huedelta = Math.trunc(360 / amount);

  for (let i = 0; i < amount; i++) {
    const hue = i * huedelta;
    colors.push(`hsla(${hue}, ${saturation}%, ${lightness}%, ${alpha})`);
  }

  return colors;
}

/**
 * @param { number } amount
 * @param { number } saturation - opt, defaut = 100
 * @param { number } lightness - opt, defaut = 50
 * @returns { [string] }
 */
export function generateHslColors (amount, saturation = 100, lightness = 50) {
  const colors = [];
  const huedelta = Math.trunc(360 / amount);

  for (let i = 0; i < amount; i++) {
    const hue = i * huedelta;
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }

  return colors;
}

/**
 * @description Attendre qu'un élément existe dans le DOM
 * @param {*} selector
 * @returns { Promise }
 */
export function waitForElement (selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new window.MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export function isJson (str) {
  // if (typeof jsonFile !== 'object') {
  //   console.log('PAS OBJECT');
  //   // return false;
  // }

  try {
    JSON.parse(str);
  } catch (e) {
    console.log('Est JSON');
    return false;
  }

  if (typeof jsonFile !== 'object') {
    console.log('PAS OBJECT');
    return false;
  }
  return true;
}
